import { render, staticRenderFns } from "./InfosParcours.vue?vue&type=template&id=0cd9f245&scoped=true&"
import script from "./InfosParcours.vue?vue&type=script&lang=js&"
export * from "./InfosParcours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9f245",
  null
  
)

export default component.exports